import { getToken } from "src/shared/utils/common";

/*
    POST a chosen frame as the ad's cover (MPN-1761).

    The endpoint this used to call was deleted in April 2026 with the Layer/Effect/Step
    teardown, and it wrote `Ad.thumbnail` -- a many-to-many that no longer exists. The
    one it calls now writes `VideoContent.thumbnail`, which is the field Pinterest and
    Meta read.
*/

export class CommandSetAdThumbnail {
  async run(adId: number, file: File, metadata: any) {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/${adId}/thumbnail/`;

    const formData = new FormData();
    formData.append("thumbnail_file", file);
    formData.append("metadata", JSON.stringify(metadata))

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Authorization": `Token ${getToken()}`,
        },
        body: formData,
      });

      if (!response.ok) {
        // The server says which rule was broken -- not an image, over 10MB, not a video
        // ad. Reporting only the status turned all four into "400 Bad Request".
        let detail = "";
        try {
          const body = await response.json();
          detail = body?.detail || body?.message || "";
        } catch {
          detail = "";
        }
        throw new Error(detail || `Upload failed: ${response.status} ${response.statusText}`);
      }
    } catch (err) {
      console.error("Error uploading thumbnail:", err);
      throw err;
    }
  }
}
